import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { GoogleLogin, CredentialResponse } from "@react-oauth/google";
import { useAuth } from "../../context/AuthContext";
import "./Login.css";

export default function Login() {
  const { credential, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (credential) {
      navigate("/", { replace: true });
    }
  }, [credential, navigate]);

  function handleSuccess(response: CredentialResponse) {
    if (response.credential) {
      login(response.credential);
      navigate("/", { replace: true });
    }
  }

  return (
    <div className="login-shell">
      <div className="login-card page-shell">
        <img src="/LogoH512.png" alt="Arkheops" className="login-logo" />
        <h1 className="page-title login-title">ADMIN</h1>
        <p className="login-subtitle">Sign in to continue</p>
        <div className="login-btn-wrap">
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={() => {}}
            useOneTap={false}
          />
        </div>
      </div>
    </div>
  );
}
